/**
 * Copyright (C) 2021 - 2025 Philips Domestic Appliances Holding B.V.
 * All rights are reserved.
 */

import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { APP_CONFIG } from '../../app.config';
import { AuthService } from '../auth/auth.service';

interface ILoginResponse {
	token: string;
}

@Injectable()
export class DevLoginService {
	private readonly appConfig = inject(APP_CONFIG);
	private readonly authService = inject(AuthService);
	private readonly router = inject(Router);
	private readonly httpClient = inject(HttpClient);

	private readonly loginEndpoint = '/api/cms/login';

	public login(username: string, password: string): Observable<void> {
		const url = this.appConfig.api.host + this.loginEndpoint;
		const body = {
			username,
			password,
		};

		return this.httpClient.post<ILoginResponse>(url, body).pipe(
			tap((response) => {
				if (response) {
					this.authService.login(response.token);
					this.router.navigateByUrl('/');
				}
			}),
			map(() => undefined),
		);
	}
}
